/* eslint-disable */
export default {
  dial: 'Componi',
  message: 'Messaggio',
  transfer: 'Trasferisci',
} as const;

// @key: @#@"dial"@#@ @source: @#@"Dial"@#@
// @key: @#@"message"@#@ @source: @#@"Message"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
